module.exports = __webpack_public_path__ + "static/media/adminSmall.12c770e7.png";